import React, { useEffect, useState } from "react";
import { ConfirmDelete, MwButton, MwSpinnerButton } from "../../ui";
import { MdOutlineAddBox } from "react-icons/md";
import { useCurrent, useDelete, useFetch } from "../../../hooks";
import ListGroupsItem from "./ListGroupsItem";
import NoDataFound from "../../ui/NoDataFound";
import { useTranslation } from "react-i18next";

const ListGroups = ({ setMode, idItemSelected, setIdItemSelected }) => {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
  const canFetchContext = Boolean(
    currentTenantId && currentCompanyId && currentBranchId
  );
  const { data: groups, loading: loadingGroups, refreshHandler } = useFetch(
    canFetchContext
      ? `${process.env.REACT_APP_Auth_API_BASE_URL}/customers/groups/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
      : null
  );
  const { data: resulltDelete, deleteItem } = useDelete();
  const [t] = useTranslation("global");

  const editHandeler = (id) => {
    setIdItemSelected(id);
    setMode("Edit");
  };

  const deleteHandeler = (id) => {
    setIdItemSelected(id);
    setShowConfirmDelete(true);
  };

  const confirmDeleteHandller = () => {
    deleteItem(
      `${process.env.REACT_APP_Auth_API_BASE_URL}/customers/groups/delete/${idItemSelected}`
    );
  };

  useEffect(() => {
    if (!resulltDelete) return;
    refreshHandler();
    setShowConfirmDelete(false);
  }, [resulltDelete, refreshHandler]);

  return (
    <>
      <ConfirmDelete
        onDeleteHandler={confirmDeleteHandller}
        msg={t("customers.confirmDeleteGroup")}
        onShow={showConfirmDelete}
        setOnShow={setShowConfirmDelete}
      />
      <div className="flex items-center">
        <div className="flex-1 font-bold text-slate-400">{t("customers.customerGroupsList")}</div>
        <MwButton inGroup={true} type="saveBtn" onClick={() => setMode("Add")}>
          <MdOutlineAddBox size={18} />
          <span>{t("customers.addNewGroup")}</span>
        </MwButton>
      </div>
      <div className="py-3 ">
        {!canFetchContext ? (
          <MwSpinnerButton withLabel={false} isFullCenter={true} />
        ) : !loadingGroups && groups?.data?.length > 0 ? (
          groups?.data?.map((item) => (
            <ListGroupsItem
              key={item._id}
              item={item}
              editHandeler={editHandeler}
              deleteHandeler={deleteHandeler}
            />
          ))
        ) : groups && groups?.data?.length < 1 ? (
          <NoDataFound msg={t("customers.noCustomerGroups")} />
        ) : (
          <MwSpinnerButton withLabel={false} isFullCenter={true} />
        )}
      </div>
    </>
  );
};

export default ListGroups;
